import { TagCategory } from 'apprise-core/category'
import { createProvider } from 'apprise-frontend-core/state/factory'
import { createFormExcludes } from 'apprise-frontend-core/utils/formexcludes'
import { CustomProperty } from 'apprise-frontend-tags/customprop/model'
import { predefinedCustomPropertyTypes } from 'apprise-frontend-tags/customprop/types'



// client cache
// --------------------------------------------------------------------------------------------------------------------------------------



export const [CategoryClientCache, useCategoryClientCache] = createProvider({

    all: [] as TagCategory[]
})



// cloning
// ---------------------------------------------------------------------------------------------------------------------------------------


export const [CategoryCloneProvider, useCategoryClone] = createProvider({

    clone: undefined! as TagCategory

})



// custom props
// ---------------------------------------------------------------------------------------------------------------------------------------


export const [CustomPropertyProvider, useRegisteredCustomProperties] = createProvider({
    types: [...predefinedCustomPropertyTypes] as CustomProperty[]
})





// form excludes
// ---------------------------------------------------------------------------------------------------------------------------------------


export type CategoryExcludes = 'form-support' | 'active' | 'condition'


export const [CategoryExcludesProvider, useCategoryExcludes] = createFormExcludes<CategoryExcludes>()